/* LinksComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./LinksRenderer");

class LinksComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value);
        this._value = value;
        this._gameEditor = context.gameEditor;
        this._logsRendered = false;

        this._logFeed = undefined;

        this._renderer = new Renderer(this);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        this._logFeed = undefined;
        this._logsRendered = undefined;
        return prom;
    }

    /******************************************/
    /* START PUBLIC API METHODS               */
    /******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setLinks(newVal);
        }
    }
    setLinks(newVal) {
        this._value = newVal;
        this.emit("Links", newVal);
    }

    getValue() {
        return this.getLinks();
    }
    getLinks() {
        return this._value;
    }

    getLogs(resultsEntity) {
        resultsEntity
            .loadRelatedJobs()
            .then((job) => {
                if (!_.isEmpty(job)) {
                    const jobEntity = job[0];
                    return jobEntity.loadRelatedLogs();
                    // return this._logFeed.whenInitialized();
                }
            })
            .then((logFeed) => {
                if (!_.isEmpty(logFeed)) {
                    this._logFeed = logFeed[0];

                    let logs = this._logFeed.logs;
                    //eventType: "FINISH"
                    let endOfLogs = logs.some(function (log) {
                        return log.eventType && log.eventType === "FINISH";
                    });
                    endOfLogs = endOfLogs || _.get(logs[0], "msg", "").startsWith("Job failed with:");
                    if (!endOfLogs) {
                        _.delay(this.getLogs.bind(this), 2000, resultsEntity, true);
                    } else {
                        this._logsRendered = true;
                    }

                    if (_.get(this._logFeed, "logs", false)) {
                        this.emit("LogAdded", _.get(this._logFeed, "logs"));
                    } else {
                        this.emit("LogCreated");
                    }
                }
            });
    }
    /******************************************/
    /* END PUBLIC API METHODS                 */
    /******************************************/
}

module.exports = LinksComponent;
